import * as angular from 'angular';
import controller from './equipmentGroupMoldDistributionGraph.controller';
import template from './equipmentGroupMoldDistributionGraph.tpl.html';

export default angular.module('aps.directive.equipmentGroupMoldDistributionGraph', [controller])
  .directive('apsEquipmentGroupMoldDistributionGraph', equipmentGroupMoldDistributionGraphDirective)
  .name;

function equipmentGroupMoldDistributionGraphDirective() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'EquipmentGroupMoldDistributionGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      group: '=',
      end: '=',
      width: '@?',
      height: '@?'
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/counts/equipmentGroupMoldDistributionGraph.directive.ts